angular.module('appMarketplace')
    .service('NotificationService', [function () {
        var service = this;

        service.notification = angular.element("#notification").kendoNotification({
            position: {
                pinned: true,
                top: 110,
                right: 30
            },
            autoHideAfter: 5000,
            stacking: "down",
            templates: [{
                type: "info",
                template: angular.element("#infoTemplate").html()
            }, {
                type: "error",
                template: angular.element("#errorTemplate").html()
            }, {
                type: "success",
                template: angular.element("#successTemplate").html()
            }],
            show: function (e) {
                e.element.parent().css({
                    zIndex: 20000 //show notification over kendo window
                });
            }

        }).data("kendoNotification");

        service.showNotification = function(message, type) {
            if (service.notification.getNotifications().length > 3) {
                service.hideNotifications();
            }
            service.notification.show({
                message: message
            }, type);
        };

        service.showErrorMessage = function (message) {
            if (message === 'Unauthorized') {
                return;
            }

            service.showNotification(message, "error");
        };

        service.showInfoMessage = function (message) {
            service.showNotification(message, "info");
        };

        service.showSuccessMessage = function (message) {
            service.showNotification(message, "success");
        };

        service.hideNotifications = function () {
            if (service.notification) {
                service.notification.hide();
            }
        };

        service.showValidationErrors = function (responseError) {
            var message = responseError && responseError.message;
            if (message) {
                service.showErrorMessage(message);
            } else if (!responseError.validationErrors || responseError.validationErrors.length === 0) {
                service.showErrorMessage("Unknown error");
            }

            if (responseError && responseError.validationErrors) {
                angular.forEach(responseError.validationErrors, function (error, field) {
                    service.showErrorMessage('Field ' + field + ': ' + error);
                });
            }
        };
    }]);


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/js/main/services/notification-service.js
// module id = 83
// module chunks = 37